import React, {useCallback} from 'react'
import '../../assets/css/pop.scss';

import {Link} from "react-router-dom";
import {FormattedMessage,FormattedNumber,FormattedDate,FormattedTime,FormattedRelativeTime} from 'react-intl';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faTimes} from "@fortawesome/pro-regular-svg-icons";
import Actions from "../../helpers/actions";
import Select from "react-select";
import Functions from "../../helpers/functions";
import IntlTelInput from "react-intl-tel-input";
import ContentLoader from "react-content-loader";


const selectStyle = {
    option: (provided, state) => ({
        ...provided,
    }),
    control: (provided, state) => ({
        ...provided,
        position:'relative',
        zIndex:1005
    }),
}

export default class notes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data:props.data,
            comments:[],
            users:[],
            user:{value:0,label:"Loading.."},
            message:""
        }
    }
    componentDidMount(){
        this.getNotes();
        this.getUsers();
    }

    async getUsers(){
        try {
            var url = Functions.generateURI(
                "/users/getAll",
                {}
            );

            var response = await fetch(url.address, url.header);
            response = await response.json();

            if(response.status){

                var users = [];
                users.push({ value: 0, label: "Select User" });
                response.data.forEach((data)=>{
                    users.push({ value: data.id, label: data.firstName+" "+data.lastName });
                });
                this.setState({user:users[0],users:users});
            } else {

            }
        } catch(error) {

        }
    }
    async getNotes(){
        try {
            var url = Functions.generateURI("/projects/getComments",{id:this.state.data.id});

            var response = await fetch(url.address, url.header);
            response = await response.json();

            if(response.status){
                this.setState({comments:response.data},()=>{
                    var contentView = document.getElementById('commentsWrapper');
                    contentView.scrollTop = 0;
                });
            } else {

            }
        } catch(error) {

        }
    }
    async createComment(){
        this.setState({loading:true});
        try {
            var url = Functions.generateURI("/projects/createComment",{
                id:this.state.data.id,
                user:this.state.user,
                message:this.state.message,
                method:"POST"
            });

            var response = await fetch(url.address, url.header);
            response = await response.json();

            if(response.status){
                this.setState({message:" ",comments:[]});
                this.getNotes();
            } else {

            }
        } catch(error) {

        }
    }
    render(){
        return (
            <div id={"popNotes"}>
                <span className={"close"} onClick={()=>{
                    // eslint-disable-next-line no-restricted-globals
                    var r = confirm("Are you sure to close ?");
                    if (r == true) {
                        this.props.closePopUp();
                        Actions.emit("closeSidePanel");
                    }
                }}><FontAwesomeIcon  icon={faTimes} size="lg"/></span>
                <div className={"row"}>
                    <div className={"columns small-12 medium-12"}>
                        <b className={"popTitle"}>DY23123123</b>
                    </div>
                    <div className={"columns small-12 medium-7"}>
                        <div className={"row comments"} id={"commentsWrapper"}>
                            {this.renderComments()}
                        </div>
                    </div>
                    <div className={"columns small-12 medium-5"}>
                        <div className="inputWrapper">
                            <div className={"inputLabel"}>Users</div>
                            <Select
                                styles={selectStyle}
                                value={this.state.user}
                                onChange={(val)=>{
                                    this.setState({user:val});
                                }}
                                options={this.state.users}
                            />
                            <div className={"inputLabel"}>Comment</div>
                            <textarea className={"input"}
                                   onChange={(e) => {
                                       this.setState({message:e.target.value});
                                   }}>{this.state.message}</textarea>
                            <div className="buttons">
                                <a className={"button"} onClick={()=>{
                                    this.createComment();
                                }}>SEND</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    renderComments(){
        if(this.state.comments.length > 0){
            return this.state.comments.map((comment,i)=>{
                return(
                    <div className={"columns small-12 comment"} key={"message"+i}>
                        <div>
                            <div className={"row"}>
                                <div className={"columns small-12"}>
                                    <div className={"row"}>
                                        <div className={"columns shrink"}>
                                            <img className={"profileImg"} src={"http://app.botonom.com/assets/img/users/0.jpg"}/>
                                        </div>
                                        <div className={"columns"}>
                                            <div className={"fullName"}>{comment.createUser.firstName+" "+comment.createUser.lastName}</div>
                                            <div className={"title"}>{comment.createUser.title}</div>
                                            <div className={"detail"}>{comment.comment}</div>
                                            <div className={"created"}>
                                                <FormattedRelativeTime value={((parseInt(comment.creationDate) - new Date().getTime()) / 1000)} numeric="auto" updateIntervalInSeconds={10} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            });
        } else {
            var shimmers = [{},{},{},{}];
            return shimmers.map((data,i)=>{
                return(
                    <div className={"columns small-12"}>
                        <div className={"row shimmer"} key={"u_"+i}>
                            <div className={"columns small-12"}>
                                <div style={{margin:20,marginBottom:0}}>
                                    <ContentLoader
                                        width={420}
                                        height={70}
                                    >
                                        <rect x="0" y="0" rx="25" ry="25" width="50" height="50" />
                                        <rect x="60" y="7" rx="4" ry="4" width="240" height="16" />
                                        <rect x="60" y="30" rx="4" ry="4" width="240" height="10" />
                                        <rect x="60" y="50" rx="4" ry="4" width="300" height="16" />
                                        <rect x="60" y="60" rx="4" ry="4" width="300" height="10" />
                                    </ContentLoader>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })
        }
    }
}

